<script>
import { mapState, mapMutations } from "vuex";
import PartsMaterials from "@/components/ContractModals/Components/BaseParts/PartsMaterials";

export default {
  extends: PartsMaterials,
  computed: {
    ...mapState("QuotationContractModal", ["partsMaterials"])
  },
  methods: {
    ...mapMutations("QuotationContractModal", [
      "setPartsMaterialsLabourQuantity",
      "setPartsMaterialsUnitsOne",
      "setPartsMaterialsHourlyPrice",
      "setPartsMaterialsUnitsTwo"
    ])
  }
};
</script>
